// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__PH476","label":"SetPasswdForm_label__3gzhg"};